import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getAllAssessment, getAllAssessmentByUser } from "../axios/axiosFunctions";
import { UserContext } from "./user";

export const AssessmentContext = createContext({
    allAssessments:null,
    setAllAssessments:()=>null,
    isLoading:true,
});

export const AssessmentsProvider = ({children})=>{

    const {currentUser} = useContext(UserContext)
    const [allAssessments,setAllAssessments] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const fetchAssessments = useCallback(async () => {
        setIsLoading(true); // Establece el estado de carga al iniciar
        try {
            let data = [];
            if(currentUser){
                data = await getAllAssessmentByUser(currentUser._id);
            }else{
                data = await getAllAssessment();
            }
            setAllAssessments(data);
            return data; // Devuelve los datos para uso externo
        } catch (error) {
            console.error("Error al cargar los Assessments:", error);
            setAllAssessments([]);
            throw error; // Propaga el error para manejo externo
        } finally {
            setIsLoading(false);
        }
    }, [currentUser]);

    useEffect(() => {
        fetchAssessments();
    }, [fetchAssessments]);

    const refetchAssessments = useCallback(async () => {
        // Simplemente llamamos a la función central de obtención de datos
        // El estado de carga y la actualización ya se manejan dentro de fetchAssessments
        return fetchAssessments();
    }, [fetchAssessments]);

    const getAssessmentBySlug = useCallback((slug) => {
        if (!allAssessments) return null;
        return allAssessments.find(assessment => assessment.slug === slug);
    }, [allAssessments]);

    const getPositionBlockBySlug = useCallback((slugAssessment,slugBlock,rol=undefined)=>{
        if (!allAssessments) return {
            before: null,
            after:null
        };
        const assessment = allAssessments.find(assessment => assessment.slug === slugAssessment);
        let blocks = [...assessment.blocks];
        if(slugAssessment === "mim_360_assessment" || slugAssessment === "lim_360_assessment"){ 
            blocks = [...assessment.ownerBlocks];
        }
        if(rol === "member" && slugAssessment === "tim_self_assessment"){
            blocks.pop();
        }
        if(rol === "senior" && slugAssessment === "tim_self_assessment"){
            blocks = [blocks[blocks.length - 1]];
        }
        if(!assessment) return null;
        const pos = blocks.findIndex(block => block.slug === slugBlock);
       if (pos === -1) {
            return { before: null, after: null };
        }
        
        const lastIndex = blocks.length - 1;
        
        return {
            before: pos > 0 ? blocks[pos - 1].slug : null,
            after: pos < lastIndex ? blocks[pos + 1].slug : null,
        };
    },[allAssessments]);

    const getBlockBySlug = useCallback((slugAssessment,slugBlock) =>{
        if (!allAssessments) return null;
        const assessment = allAssessments.find(assessment => assessment.slug === slugAssessment);
        if(!assessment) return null;
        if(slugAssessment === "mim_360_assessment" || slugAssessment === "lim_360_assessment"){
            return assessment.ownerBlocks.find(block => block.slug === slugBlock);
        }
        return assessment.blocks.find(block => block.slug === slugBlock);
    }, [allAssessments]);
    
    const value = {allAssessments,setAllAssessments,isLoading,getAssessmentBySlug,getBlockBySlug,getPositionBlockBySlug,refetchAssessments};

    return <AssessmentContext.Provider value={value}>{children}</AssessmentContext.Provider>
}